import { jsx as n } from "react/jsx-runtime";
import { c } from "../../clsx-OuTLNxxd.js";
import '../../assets/SectionNotification.css';const i = {
  "section-notification": "_section-notification_10vkx_1",
  "section-notification--fullwidth": "_section-notification--fullwidth_10vkx_10"
}, a = ({ fullWidth: t = !1, children: o }) => /* @__PURE__ */ n(
  "div",
  {
    className: c(i["section-notification"], {
      [i["section-notification--fullwidth"]]: t
    }),
    children: o
  }
);
export {
  a as SectionNotification
};
//# sourceMappingURL=SectionNotification.js.map
